/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Item } from '../../models/item';

export interface RemoveParent$Params {
  itemId: string;
}

export function removeParent(http: HttpClient, rootUrl: string, params: RemoveParent$Params, context?: HttpContext): Observable<StrictHttpResponse<Item>> {
  const rb = new RequestBuilder(rootUrl, removeParent.PATH, 'post');
  if (params) {
    rb.query('itemId', params.itemId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Item>;
    })
  );
}

removeParent.PATH = '/admin/items/parent/remove';
